import React, { useState } from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../../../design-system/DSBox';
import DSTypography from '../../../design-system/Typography/DSTypography';
import DSModal from '../../../design-system/DSModal';
import OnboardingWizard from '../../../components/OnboardingWizard';
import DSCollapsibleSection from '../../../design-system/DSCollapsibleSection';
import GuideReaderModal from './GuideReaderModal';
import useStudioGuides from '../../../hooks/useStudioGuides';
import { GuideItem } from '../../../api/studio';
import { ReactComponent as RightIcon } from '../../../design-system/Icons/RightIcon.svg';

const GuidesSection = () => {
  const { palette, spacing } = useTheme();
  const { data } = useStudioGuides();
  const [openGuide, setOpenGuide] = useState<GuideItem | null>(null);

  const guides = data?.items ?? [];
  if (guides.length === 0) {
    return null;
  }

  const handleClose = () => setOpenGuide(null);

  return (
    <>
      <DSCollapsibleSection title="Guides">
        {guides.map((guide, index) => (
          <DSBox
            key={guide.id}
            onClick={() => setOpenGuide(guide)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: spacing(2.25),
              padding: spacing(2.25, 3),
              cursor: 'pointer',
              borderTop: index > 0 ? `1px solid ${palette.white[5]}` : 'none',
              transition: 'background .15s ease',
              '&:hover': { backgroundColor: palette.white[5] },
            }}
          >
            <DSBox sx={{ flex: 1, minWidth: 0 }}>
              <DSTypography
                variant="value"
                sx={{ color: palette.text.primary }}
              >
                {guide.title}
              </DSTypography>
              <DSTypography
                variant="body2"
                sx={{
                  color: palette.text.secondary,
                  marginTop: spacing(0.5),
                }}
              >
                {guide.subtitle}
              </DSTypography>
            </DSBox>
            <DSBox
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: spacing(1),
                flexShrink: 0,
                color: palette.white[56],
              }}
            >
              <DSTypography
                variant="body2"
                sx={{ color: palette.text.secondary }}
              >
                {guide.displayMode === 'slides'
                  ? 'Slideshow'
                  : `${guide.sections?.length ?? 0} sections`}
              </DSTypography>
              <RightIcon width={20} height={20} />
            </DSBox>
          </DSBox>
        ))}
      </DSCollapsibleSection>

      {openGuide?.displayMode === 'slides' && (
        <DSModal open onClose={handleClose}>
          <OnboardingWizard modal onComplete={handleClose} />
        </DSModal>
      )}
      {openGuide && openGuide.displayMode !== 'slides' && (
        <GuideReaderModal guide={openGuide} open onClose={handleClose} />
      )}
    </>
  );
};

export default GuidesSection;
